export default __webpack_public_path__ + "static/media/hourglass-end-solid.42445d1d.svg";